import { OTHER_PROPS } from 'common/constants/component-props';

export enum LottieDirection {
	forward = 'forward',
	backward = 'backward',
}

export enum LottieTrigger {
	// --- Component scope ---

	// on page load + in viewport
	load = 'load',
	// on block click
	onClick = 'onClick',
	// on block hover
	onHover = 'onHover',
	// on page scroll
	scroll = 'scroll',
	// on block mousemove
	cursor = 'cursor',

	// --- Card scope ---

	// on select any answer in card
	onCardAnswer = 'onCardAnswer',
	// on answer card correctly
	onCardAnswerCorrect = 'onCardAnswerCorrect',
	// on answer card incorrectly
	onCardAnswerIncorrect = 'onCardAnswerIncorrect',
	// on leads form card submit click
	onSubmit = 'onSubmit',

	// todo: how to run animation when clicking on some particular block in card?
	//       like click on `ButtonA` will start animation of `ButtonB`
}

export const defaultProps = {
	[OTHER_PROPS.lottie.ltTrigger]: LottieTrigger.load,
	[OTHER_PROPS.lottie.ltKeepRatio]: true,
	[OTHER_PROPS.lottie.ltOffset]: [0, 100] as [number, number],
	[OTHER_PROPS.lottie.ltSpeed]: 1,
	[OTHER_PROPS.lottie.ltLoop]: false,
	[OTHER_PROPS.lottie.ltDir]: LottieDirection.forward,
};
